<template>
  <button @click="listKPI" type="button" :class="`btn btn-sm btn-${type === 'bd' ? 'primary' : 'secondary'} mr-1`">
    <font-awesome-icon icon="bullseye" />&nbsp;{{ type === 'bd' ? $t('setupBD') : $t('setupAM') }}
    <b-modal size="xl" v-model="showList" :title="getTitle()" @ok="$emit('change')" @close="$emit('change')" ok-only
      no-close-on-backdrop no-enforce-focus>
      <div class="row">
        <div class="col-12">
          <div class="tile">
            <div class="form-inline">
              <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                :placeholder="$t('keyword')" />
              <admin-user-select :model="filterFormModel" attribute="user"
                :placeHolder="$t(type === 'am' ? 'selectAM' : 'selectBD')"
                :roleFilter="type === 'am' ? 'am' : 'sales'" />
              <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
              <button @click="() => { reset(); load() }" class="btn btn-secondary mr-1 mb-1">Reset</button>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="c-sorting"
            v-if="['owner', 'admin', 'account', 'operationsManager'].includes($store.state.user.role)">
            <div class="row">
              <div class="col-lg-12 c-sorting__right">
                <div class="c-sorting__btn">
                  <button @click="create" class="btn btn-sm btn-success">
                    <font-awesome-icon icon="plus" />&nbsp;{{ $t('create') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="c-paging clearfix">
            <div class="c-paging__count" v-if="itemCount">
              {{ $t('found', [itemCount]) }}
            </div>
            <div class="c-paging__right">
              <div class="c-paging__numbers">
                <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                  v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                  @input="load"></b-pagination>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12" v-if="items.length">
          <div class="c-smart-table tile">
            <div class="row c-smart-table__title">
              <div class="col-lg-3">{{ $t('appliedTo') }}</div>
              <div class="col-lg-3">{{ $t('info') }}</div>
              <div class="col-lg-2 text-right">{{ $t('amount') }}</div>
              <div class="col-lg-2 text-right">{{ $t('trialCustomer') }}</div>
              <div class="col-lg-2"></div>
            </div>
            <div class="row" v-for="item in items" :key="item._id">
              <div class="col-lg-3">
                <div>
                  <b class="c-smart-table__label">{{ $t('appliedTo') }}: </b>
                  <span>{{ item.user.name }}</span>
                </div>
              </div>
              <div class="col-lg-3">
                <div>
                  <b>{{ $t('createdBy') }}: </b> {{ item.createdBy.name }}
                </div>
                <div>
                  <b>{{ $t('createdAt') }}: </b> {{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}
                </div>
                <div v-if="item.updatedBy">
                  <b>{{ $t('updatedBy') }}: </b> {{ item.updatedBy.name }}
                </div>
                <div v-if="item.updateTime && item.updateTime != item.createTime">
                  <b>{{ $t('updatedAt') }}: </b> {{ item.updateTime | moment('DD/MM/YYYY HH:mm:ss') }}
                </div>
              </div>
              <div class="col-lg-2 text-right">
                <div>
                  <b class="c-smart-table__label">{{ $t('amount') }}: </b>
                  <span>{{ item.amount | numFormat }}</span>
                </div>
              </div>
              <div class="col-lg-2 text-right">
                <div>
                  <b class="c-smart-table__label">{{ $t('trialCustomer') }}: </b>
                  <span>{{ item.trialCustomerAmount | numFormat }}</span>
                </div>
              </div>
              <div class="col-lg-2 text-right">
                <div class="c-smart-table__content">
                  <div class="c-buttons clearfix is-2">
                    <div class="c-buttons__col">
                      <button @click="update(item._id)" type="button"
                        v-if="['owner', 'admin', 'account', 'operationsManager'].includes($store.state.user.role)"
                        class="btn btn-sm btn-info mr-1">
                        <font-awesome-icon icon="edit" />&nbsp;{{ $t('edit') }}
                      </button>
                      <button @click="del(item._id)" type="button"
                        v-if="['owner', 'admin', 'account', 'operationsManager'].includes($store.state.user.role)"
                        class="btn btn-sm btn-danger mr-1">
                        <font-awesome-icon icon="trash" />&nbsp;{{ $t('delete') }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 text-center text-danger" v-if="!items.length">
          <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
          <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
        </div>

        <div class="col-12" v-if="itemCount">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
            v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize" @input="load">
          </b-pagination>
        </div>
      </div>
    </b-modal>
    <b-modal v-model="showForm" :title="''" @ok="save" no-close-on-backdrop no-enforce-focus>
      <admin-user-select :label="$t(type)" :model="formModel" attribute="user" :multiple="false"
        :placeHolder="$t(type === 'am' ? 'selectAM' : 'selectBD')" :roleFilter="type === 'am' ? 'am' : 'sales'"
        :errors="formErrors" />
      <form-input :label="$t('amount')" :model="formModel" attribute="amount" :errors="formErrors" />
      <form-input :label="$t('trialCustomer')" :model="formModel" attribute="trialCustomerAmount"
        :errors="formErrors" />
    </b-modal>
  </button>
</template>

<script>
import List from '@/mixins/List';
import CRUD from "@/mixins/CRUD";
import AdminUserSelect from "@/components/AdminUserSelect";

export default {
  components: { AdminUserSelect },
  props: ['kpi', 'type'],
  mixins: [List, CRUD],
  data() {
    return {
      showList: false,
      autoLoad: false,
      service: 'admin-user-kpi-item',
      defaultFormModel: {
        kpi: this.kpi._id,
        type: this.type,
        user: null,
        amount: 0,
        trialCustomerAmount: 0
      },
      defaultFilterFormModel: {
        kpi: this.kpi._id,
        type: this.type
      }
    }
  },
  i18n: {
    messages: {
      en: {
        title: "Setup {0} Kpi {1}",
        bd: "BD",
        am: "AM",
        setupBD: "Setup BD",
        setupAM: "Setup AM",
        month: 'Month',
        year: 'Year',
        selectAM: "Select AM",
        selectBD: "Select BD",
        amount: "Revenue",
        trialCustomer: "Trial customers",
        appliedTo: "Applied to",
        createdBy: "Created by",
        createdAt: "Created at",
        updatedBy: "Updated by",
        updatedAt: "Updated at",
      },
      vi: {
        title: "Cài đặt {0} Kpi tháng {1}",
        bd: "BD",
        am: "AM",
        setupBD: "Cài đặt BD",
        setupAM: "Cài đặt AM",
        month: 'Tháng',
        year: 'Năm',
        selectAM: "Chọn AM",
        selectBD: "Chọnt BD",
        amount: "Doanh thu",
        trialCustomer: "Số khách hàng dùng thử",
        appliedTo: "Áp dụng cho",
        createdBy: "Tạo bởi",
        createdAt: "Tạo lúc",
        updatedBy: "Cập nhật bởi",
        updatedAt: "Cập nhật lúc",
      }
    }
  },
  methods: {
    getTitle() {
      return this.$t('title',
        [
          this.$t(this.type),
          (this.kpi.month < 10 ? '0' + this.kpi.month : this.kpi.month) + '-' + this.kpi.year
        ]
      );
    },
    listKPI() {
      this.showList = true;
      this.load();
    },
  }
}
</script>